import { defineComponent as _defineComponent } from 'vue'

export { OzIconButtonColorScheme as OzBackButtonColorScheme } from '@@/library/v4/components/OzIconButton.vue'
const __default__ = {}

import { __ } from '@@/bits/intl'
import OzIconButton, { OzIconButtonColorScheme } from '@@/library/v4/components/OzIconButton.vue'
import { withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzBackButton',
  props: {
    darkMode: { type: [Boolean, String], default: 'auto' },
    disabled: { type: Boolean, default: false },
    href: { default: undefined },
    label: { default: __('Go back') },
    colorScheme: { default: OzIconButtonColorScheme.Secondary },
    iconSize: { default: undefined }
  },
  emits: ['click'],
  setup(__props: any) {





return { __sfc: true,OzIconButton }
}

})